import type { AuthorizationResponse } from "@arcadeai/arcadejs/resources/index.mjs";
import { getEngineApi } from "@/lib/api";

const AUTH_WAIT_SECONDS = 59;
const AUTH_WAIT_TIMEOUT_MS = 5 * 60 * 1000;

/**
 * Polls the engine's auth/status endpoint until the authorization flow
 * reaches a terminal state. Each request long-polls server-side for up to
 * 59 seconds, so the client loop only retries when the auth flow is still
 * pending after a long-poll completes.
 */
export async function waitForAuthCompletion(
  authId: string,
  organizationId: string,
  projectId: string
): Promise<AuthorizationResponse> {
  const deadline = Date.now() + AUTH_WAIT_TIMEOUT_MS;
  const api = getEngineApi({ organizationId, projectId });

  while (Date.now() < deadline) {
    const { data } = await api.get<AuthorizationResponse>("/auth/status", {
      params: {
        id: authId,
        wait: AUTH_WAIT_SECONDS,
      },
    });

    if (data.status === "completed" || data.status === "failed") {
      return data;
    }
  }

  throw new Error("Timed out waiting for authorization to complete");
}
